/**
 * Feature toggles — CRA inlines REACT_APP_* at build time.
 * US Compose sets REACT_APP_GOOGLE_AUTH_ENABLED / REACT_APP_PRIVACY_POLICY_ENABLED;
 * CIS builds leave them unset (default off).
 */

function envFlag(name, defaultValue = false) {
  const raw = process.env[name];
  if (raw == null || String(raw).trim() === "") {
    return defaultValue;
  }
  return ["1", "true", "yes", "on"].includes(String(raw).trim().toLowerCase());
}

export const FEATURE_PRIVACY_POLICY = envFlag(
  "REACT_APP_PRIVACY_POLICY_ENABLED",
  false,
);
export const FEATURE_GOOGLE_AUTH = envFlag(
  "REACT_APP_GOOGLE_AUTH_ENABLED",
  false,
);
